module.exports = __webpack_public_path__ + "static/media/Canimolt_esquela_web.5bc66714.jpg";